import { SWAN_STYLE_KEY_MAP } from '@vp/swan';

const SWAN_STYLE_KEYS = [
  SWAN_STYLE_KEY_MAP.standardTile,
  SWAN_STYLE_KEY_MAP.popover,
  SWAN_STYLE_KEY_MAP.pricing,
  SWAN_STYLE_KEY_MAP.button,
  SWAN_STYLE_KEY_MAP.icon
];

export { SWAN_STYLE_KEYS };
//# sourceMappingURL=src-constants-swanStyleKeys.js.map
